import { UPE_COLORS, USO_STROKE, fmtNum } from "../../lib/format";

// Mapa genérico: mosaico proporcional a la superficie, coloreado por estatus
export default function GridMap({ upes, onSelect, selectedId, filtroUso = "", filtroEstatus = "", mini = false }) {
  const list = (upes || []).filter(
    (u) => (!filtroUso || u.uso === filtroUso) && (!filtroEstatus || u.estatus === filtroEstatus)
  );
  if (list.length === 0)
    return (
      <div data-testid="gridmap-empty" className="flex items-center justify-center text-slate-400 text-sm border-2 border-dashed border-slate-200 rounded-lg" style={{ minHeight: mini ? 120 : 220 }}>
        Sin UPEs registradas. Agrega unidades manualmente o extráelas del Master Plan con IA.
      </div>
    );
  const maxS = Math.max(...list.map((u) => u.superficie_m2 || 0), 1);
  return (
    <div className="flex flex-wrap gap-2" data-testid="gridmap">
      {list.map((u) => {
        const ratio = Math.sqrt((u.superficie_m2 || 0) / maxS);
        const basis = mini ? 90 + ratio * 110 : 150 + ratio * 230;
        const h = mini ? 64 : 100 + ratio * 44;
        return (
          <button
            key={u.id}
            data-testid={`gridmap-upe-${u.clave}`}
            onClick={() => onSelect && onSelect(u)}
            title={`${u.clave} · ${u.uso} · ${fmtNum(u.superficie_m2 || 0)} m² · ${u.estatus}`}
            style={{ flex: `1 1 ${basis}px`, minHeight: h, background: UPE_COLORS[u.estatus] || "#CBD5E1", borderColor: USO_STROKE[u.uso] || "#64748B" }}
            className={`relative rounded-md border-2 text-left p-2 transition-all duration-200 hover:scale-[1.02] hover:shadow-md hover:z-10 ${
              selectedId === u.id ? "ring-2 ring-[#002B49] ring-offset-2" : ""
            }`}>
            <p className="font-display font-bold text-xs sm:text-sm text-[#002B49] leading-tight truncate">{u.clave}</p>
            {!mini && (
              <>
                <p className="text-[10px] text-[#002B49]/70 truncate">{u.uso}</p>
                {u.superficie_m2 > 0 && <p className="text-[10px] text-[#002B49]/70">{fmtNum(u.superficie_m2)} m²</p>}
              </>
            )}
            {u.avance != null && (
              <span className="absolute bottom-1.5 right-2 text-[10px] font-bold text-[#002B49]/80">{u.avance}%</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
